module.exports = __webpack_public_path__ + "07f55772ab2cf1d2c1559e70521e2b12.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-teal.png
// module id = 2907
// module chunks = 0